import React, { Component } from 'react';
import ReactGA from 'react-ga';
// import logo from './logo.svg';
import { Modal, ModalHeader, ModalFooter, ModalBody, Button } from 'reactstrap';
import 'react-toastify/dist/ReactToastify.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import meme from './91e7400d06a4ace1.gif';
import hjlogo from './hyperjot.io-logo.png';
import initialStore from './store';
import { configOptions, retrieveConfig } from './config';
import { ToastContainer, toast, Slide } from 'react-toastify';
import { Shake } from 'reshake';
// import howto from './howto';
import news from './news';
import { pickGreeting } from './greetings';

const equals = ( a, b ) => {
  if( typeof a !== 'object' || typeof b !== 'object' ) return false;

  for( var key_a in a ){

    if( ! b.hasOwnProperty( key_a ) ) return false;

    if( typeof a[key_a] === 'object' ){

      if( ! equals( a[key_a], b[key_a] ) ) return false;

    } else if( a[key_a] !== b[key_a] ) return false;

  }
  for( var key_b in b ){
    if( ! a.hasOwnProperty( key_b ) ) return false; // we already tested matching keys for equality, so we don't need to do it again.
  }
  return true;
};

const leadingNumberRegexp = /^[-+]?[0-9]*\.?[0-9]+/;
const numbersRegexp = /[-+]?[0-9]*\.?[0-9]+/g;

const parseDice = ( value ) => {

    var dice = null;

    if( typeof value === 'string' ){
      dice = value.match( /\bd(-?\d+)\b/ig );
    }

    return dice;

}

const rollDie = ( max ) => {

  max = parseFloat( max.substr( 1 ) );
  var roll;

  if( max > 1 )
    roll = Math.ceil( Math.random() * max );

  if( max < -1 )
    roll = Math.floor( Math.random() * max );

  if( Math.abs( max ) === 1 )
    roll = Math.random() * max;

  if( max === 0 )
    roll = 'undefined';

  return [roll,max];

}

const rollDice = ( arr ) => {

  if( arr === null ) return null;

  let rolls = [];

  for( let i = arr.length - 1; i >= 0; i-- ){
    rolls.unshift( rollDie( arr[ i ] ) );
  }

  return rolls;

}

const copy = require('copy-text-to-clipboard');

const action_key = {
  // The following are Jot operations.
  'add': { word: 'Add', emoji: '➕', full: '➕ Add' },
  'edit': { word: 'Edit', emoji: '📝', full: '📝 Edit' },
  'recycle': { word: 'Recycle', emoji: '♻️', full: '♻️ Recycle' },
  'copy': { word: 'Copy', emoji: '💽', full: '💽 Copy' },
  'share': { word: 'Share', emoji: '📲', full: '📲 Share' },
  'url': { word: 'URL', emoji: '🔗', full: '🔗 URL' },
  'move': { word: 'Move', emoji: '🖐️', full: '🖐️ Move' },
  'move_select': { word: 'Move Here', emoji: '✔️', full: '✔ Move Here️' },
  'delete': { word: 'Delete', emoji: '💥', full: '💥 Delete' },
  'export': { word: 'Export', emoji: '📤', full: '📤 Export' },
  'import': { word: 'Import', emoji: '📥', full: '📥 Import' },
  'reroll': { word: 'Reroll', emoji: '🎲', full: '🎲 Reroll' },
  'increment': { word: '+1', emoji: '➕', full: '➕' },
  'decrement': { word: '-1', emoji: '➖', full: '➖' },
  // 'todo-complete': { word: '✅', emoji: '✅', full: '✅' },
  'todo-complete': { word: '✔️️', emoji: '✔️️', full: '✔️️' },
  'todo-incomplete': { word: '🔲', emoji: '🔲', full: '🔲' },
  'sort-abcd': { word: 'Alpha Sort', emoji: '🔠', full: '🔠 Alpha Sort' },
  'sort-cache': { word: 'Cache Sort', emoji: '📚', full: '📚 Cache Sort' },
  'sort-dragon': { word: 'Dragon Drop Sort', emoji: '🐉', full: '🐉 Dragon Drop Sort' },

  // The following are NOT Jot operations.
  'cancel': { word: 'Cancel', emoji: '🚫', full: '🚫 Cancel' },
  'save': { word: 'Save', emoji: '💾', full: '💾 Save' },
};

const sorts = ['abcd','cache']; // ,'dragon'];

const roots = ['__root','__recycled','__incoming','__split','__search','__config'];
const reserved = roots.concat( ['__created','__updated','__todo','__order','__sort','__timestamp','__configversion','__focus','__newshare'] );

ReactGA.initialize('UA-121185120-1');
ReactGA.pageview( window.location.pathname + window.location.search );

class App extends Component {

  constructor(props){
    super(props);
    this.state = {
      modal: false, // Is the modal open or not.
      modalType: false, // options are 'edit','delete','add'
      modalCallback: false, // a function to execute when the primary action button is pressed on the modal
      modalValue: false,
      modalInitialValue: false, // value of the jot being edited when the modal opens initially.
      modalJotProps: false,

      modalMoveJot: false, // this is for moving jots operation; it feeds the jot that will be moved into the modal window.
    };

    this.parseShare = this.parseShare.bind(this);
    this.firstTouch = this.firstTouch.bind(this);

    this.hydrate = this.hydrate.bind(this);
    this.persist = this.persist.bind(this);

    this.focusModal = this.focusModal.bind(this);

    this.clearModal = this.clearModal.bind(this);
    this.updateModalValue = this.updateModalValue.bind(this);
    this.modalPrimaryAction = this.modalPrimaryAction.bind(this);
    this.createRequestModalFunc = this.createRequestModalFunc.bind(this);

    // this gets the data or initialData loaded into the app.
    this.hydrate();

    this.getConfig = retrieveConfig( this.store );

    this.forceReRender = this.forceReRender.bind(this);

    this.modalInput = React.createRef();
    this.importInput = React.createRef();

    // debug only
    // window.store = this.store;
  }

  parseShare(){
    // interpret Add GET param command if present.
    var get = window.location.href.split('/?');

    if( get.length > 1 ){

      var parts = get[1].split('=');
      var add = parts.indexOf('add');

      if( add > -1 ){
        // we have an add param:
        let payload = parts[ add + 1 ];
        var json = false;

        try {
          let comp = decodeURIComponent( payload );
          json = JSON.parse( comp );
        } catch(e){
          // the JSON was invalid. Abandon!
        } finally {
          if( json !== false ){
            this.store['__incoming'] = {
              ...this.store['__incoming'],
              ...json,
              '__newshare': true
            };
            this.persist();
          }

          // go back home and get rid of that GET param.
          window.location.href = window.location.protocol + '//' + window.location.host

        } // end finally

      } // end if add > -1

    }
  }

  componentDidMount(){

    this.parseShare();

    document.addEventListener('click',this.firstTouch);

  } // end componentDidMount

  // this is only called in the constructor.
  hydrate(){
    const data = JSON.parse( window.localStorage.getItem('hyperjot') );

    // testing only
    if( window.location.search === '?debug' ){
      this.store = initialStore;
    } else if (data && data !== null) {
      this.store = data;
      if( this.store['__incoming'].hasOwnProperty('__newshare') ){
        delete this.store['__incoming']['__newshare'];
        this.persist();
        toast(<span><Shake h={25} v={5} r={-50} dur={400} int={10} max={100} fixed={ true } >🔔</Shake> You got a new HyperShare! Look in HyperShares to see it!</span>,{
          autoClose: 8000
        });
      } else {
        toast( pickGreeting() );
      }
    } else {
      this.store = initialStore;
      toast('😄 Hey there! Welcome to HyperJot.io',{
        onClose: () => { 
          toast(<span><span role="img" aria-label="finger pointing up">☝️</span> Tap on <strong>HyperJot</strong> at the top to begin!</span>,{
            autoClose: 5000
          });
        }
      });
    }

    if( ! this.store.hasOwnProperty('__search') ){
      this.store['__search'] = {};
    }

    if( this.store.hasOwnProperty('__config') ){
      if( this.store['__config'].hasOwnProperty('__configversion') ){
        if( this.store['__config']['__configversion'] < configOptions['__configversion'] ){
          // overwrite config with new version
          this.store['__config'] = configOptions;
          toast('🛠️ Applying new version updates...', {
            hideProgressBar: false
          });
        } else {
          // don't do anything; our config is up to date
        }
      } else {
        // we don't have a __configversion, so we are *really* out of date! assign new config
        this.store['__config'] = configOptions;
      }
    } else {
      // we don't have a config
      this.store['__config'] = configOptions;
    }

  }

  persist(){
    window.localStorage.setItem('hyperjot', JSON.stringify( this.store ) );
  }

  updateModalValue(e){
    // console.log('updateModalValue event obj', e.target );
    if( e && e.target.hasOwnProperty( 'value' ) && typeof e.target.value === 'string' ){

      let val = e.target.value.replace(this.store['__split'],'');

      this.setState(() => ({
        modalValue: val
      }));

    }
  }

  createPerformMoveFunc(){
    let t = this;
    return ( jot_target ) => {
      let target_path = jot_target.getPath();
      let moving_jot = t.state.modalMoveJot;
      let moving_jot_path = moving_jot.getPath( -1 );
      let moving_jot_val = t.state.modalMoveJot.props.value;

      // No clobbering:
      if( target_path.hasOwnProperty( moving_jot_val ) ){

        toast('⚠️ Can\'t move Jot here; identical Jot exists.');

        return;

      }
 
      // what does this do? i forgot
      if( jot_target.props.value === moving_jot.props.value ) return;

      // copy it over:
      let copy_value = moving_jot_path[ moving_jot_val ];
      target_path[ moving_jot_val ] = copy_value;
      // todo - recurse and merge subjots.

      // trying to highlight after move
      // it works, just not right away when you actually do the move :/
      // target_path['__focus'] = true;

      // delete old jot
      let moving_jot_parent_path = moving_jot.getPath( -1 );
      delete moving_jot_parent_path[ moving_jot_val ];

      moving_jot.props.refresh();

      t.persist();

      t.clearModal();
    }
  }

  createRequestMoveFunc(){
    let t = this;
    return ( jot_moving ) => {
      var jot_to_move = jot_moving;
      t.setState(
        ( prevState, props ) => ({
          modalMoveJot: jot_to_move
        })
      );
    }
  }

  // requestModal is created here:
  createRequestModalFunc(){
    let t = this;
    return ( type, callback, initVal, p ) => {
      // initValue is the initial value for the textarea if it is being utilized in the modal.
      t.setState(
        ( prevState, props ) => ({
          // changing the modal in state will make the modal pop up.
          modal: true,
          modalType: type,
          modalCallback: callback,
          modalInitialValue: initVal,
          modalJotProps: p
        }),
        () => {
          if( type === 'add' || type === 'edit' )
            t.focusModal();
        }
      );
    };
  }

  clearModal(){
    var that = this;

    this.setState({
      modal: false,
    }, () => {
      setTimeout( () => {

        that.setState({
          modalType: false,
          modalCallback: false,
          modalInitialValue: false,
          modalJotProps: false,
          modalMoveJot: false,
          modalValue: false,
        });

      }, 250 );
    });
  }

  modalPrimaryAction(){
    this.state.modalCallback( this.state.modalValue, this );
    this.clearModal();
  }

  focusModal(){
    if( this.modalInput.current !== null ){
      this.modalInput.current.focus();
      let val = this.modalInput.current.value;
      this.modalInput.current.value = '';
      this.modalInput.current.value = val;
    }
  }

  firstTouch( e ){
    if( e && e.target && e.target.classList.contains('jot') ){

      this.setState({
        firstTouch: true
      });

    }
  }

  forceReRender(){
    this.forceUpdate();
  }

  render() {

    let verbs = {
      'add': 'Jot',
      'edit': 'Jot',
      'move': 'Jot',
      'recycle': 'Jot',
      'import': 'HyperJot',
    };

    let modalBody;

    // Our modal will be different for a delete action than it will be for a add/edit action.
    if( this.state.modalType === 'move' ){
      // we are moving a jot
      modalBody = (
        <ModalBody>
          Moving:
          { React.createElement( HyperJot, {
              ...this.state.modalJotProps,
              allowedActions: []
            }, null ) }
          Into:
          <HyperJot start="__root" value="HyperJot" store={ this.store } persist={ this.persist }  allowedActions={ ['move_select'] } performMove={ this.createPerformMoveFunc() } moveJot={ this.state.modalMoveJot } getConfig={ this.getConfig } />
        </ModalBody>
      );

    } else if( this.state.modalType === 'recycle' ){
      // we are recycling a jot
      modalBody = (
        <ModalBody>
          Move this jot and everything contained within it to Recycled Jots?
          { React.createElement( HyperJot, {
              ...this.state.modalJotProps,
              allowedActions: ['copy','share'],
              getConfig: this.getConfig
            }, null ) }
        </ModalBody>
      );

    } else if( this.state.modalType === 'import' ){

      modalBody = (
        <ModalBody>
          Select the HyperJot .json backup file to import.<br/><br/>
          <input ref={ this.importInput } type="file" id="selectFiles" /><br/><br/>
          ⚠️ WARNING: This will overwrite everything! There is no undo!
        </ModalBody>
      );

    } else {

      modalBody = (
        <ModalBody>
          <textarea ref={ this.modalInput } onChange={ this.updateModalValue } defaultValue={ this.state.modalInitialValue }/>
        </ModalBody>
      );

    }

    let primaryButton = <Button outline size="sm" color="info" className="modal-primary-action" onClick={ this.modalPrimaryAction }>{ this.state.modalType ? action_key[ this.state.modalType ].full : '' }</Button>;

    return (
        <div className={ "App" + ( this.state.firstTouch ? " x" : '' ) }>

          <HyperJot start="__root" value="HyperJot" store={ this.store } persist={ this.persist } requestModal={ this.createRequestModalFunc() } requestMove={ this.createRequestMoveFunc() } allowedActions={ ['add','edit','recycle','copy','share','move','url','export','import','date','reroll','counter','todo','sort'] } getConfig={ this.getConfig } />

          <HyperJot start="__search" value="HyperSift" store={ this.store } persist={ this.persist } requestModal={ this.createRequestModalFunc() } requestMove={ this.createRequestMoveFunc() } allowedActions={ ['add','edit','delete','copy','date','reroll','counter','todo'] } getConfig={ this.getConfig } />

          <HyperJot start="__incoming" value="HyperShares" store={ this.store } persist={ this.persist } requestModal={ this.createRequestModalFunc() } requestMove={ this.createRequestMoveFunc() } allowedActions={ ['recycle','copy','share','move','date','sort','todo','url'] } getConfig={ this.getConfig }/>

          <HyperJot start="__recycled" value={ ( this.getConfig('emoji-prefix-recycled') ? '🗑️ ' : '' ) + 'Recycled Jots'} styleClass="ghost-jots" store={ this.store } persist={ this.persist } requestModal={ this.createRequestModalFunc() } requestMove={ this.createRequestMoveFunc() } allowedActions={ ['delete','copy','share','move','date','reroll','sort'] } getConfig={ this.getConfig } />

          <HyperJot start="__config" value={ ( this.getConfig('emoji-prefix-config') ? '⚙️ ' : '' ) + 'Configuration'} styleClass="ghost-jots" store={ this.store } persist={ this.persist } requestModal={ this.createRequestModalFunc() } requestMove={ this.createRequestMoveFunc() } forceReRender={ this.forceReRender } allowedActions={ ['copy','reroll','counter','share','date','todo'] } getConfig={ this.getConfig } />

          <HyperJot isSearchResult={ true } start="__root" value="HyperNews" store={ news } persist={ () => {} } requestModal={ () => {} } requestMove={ () => {} } allowedActions={ ['copy','share','date','reroll','todo','url'] } getConfig={ this.getConfig }/>


          <footer className="mx-auto d-block p-2 text-center">
          <img className="logo" src={ hjlogo } alt="HyperJot.io logo"/>
            <small>
              HyperJot.io v3.2 &copy;&nbsp;
              <a href="https://twitter.com/enchiridiontech" target="_blank" rel="noopener noreferrer">Nick</a>&nbsp;
              <span title="2018">MMXVIII</span>
            </small>
          </footer>
          {/*Modals*/}
          {/*How to autofocus a modal: https://stackoverflow.com/questions/28889826/react-set-focus-on-input-after-render */}
          <Modal isOpen={ this.state.modal !== false } className={ 'modal-state-' + this.state.modalType }>
            <ModalHeader>{ typeof this.state.modalType === 'string' ? this.state.modalType : '' } { verbs[ this.state.modalType ] || 'Jot' }</ModalHeader>

            { modalBody }

            <ModalFooter>
              <Button outline size="sm" color="secondary" onClick={ this.clearModal }>{ action_key[ 'cancel' ].full }</Button>

              { this.state.modalType !== 'move' ? primaryButton : '' }

            </ModalFooter>
          </Modal>
          <ToastContainer
            position="bottom-center"
            autoClose={3000}
            hideProgressBar={ true }
            transition={ Slide }
            closeButton={ false }
            className='text-center'
          />
        </div>
    );
  }
}

class HyperJot extends Component {

  constructor(props){
    super(props);


    this.state = {
      recentlyclosed: false,
      shake: false,
      expanded: false,
      dice: null,
      rolls: null,
      todo_complete: null,
      multiline: false, // This indicates whether the text in an unexpanded jot wraps to the next line (true) or not (false).
    };

    // button function bindings
    this.add = this.add.bind(this);
    this.edit = this.edit.bind(this);
    this.recycle = this.recycle.bind(this);
    this.del = this.del.bind(this);
    this.copy = this.copy.bind(this);
    this.share = this.share.bind(this);
    this.move = this.move.bind(this);
    this.move_select = this.move_select.bind(this);
    this.url = this.url.bind(this);
    this.export_json = this.export_json.bind(this);
    this.import_json = this.import_json.bind(this);
    this.show_created_updated = this.show_created_updated.bind(this);
    this.counter = this.counter.bind(this);

    this.cycleSort = this.cycleSort.bind(this);

    // hyperjot function bindings
    this.getUnreservedJots = this.getUnreservedJots.bind(this);
    this.refreshDice = this.refreshDice.bind(this);
    this.refreshTodo = this.refreshTodo.bind(this);
    this.refreshSort = this.refreshSort.bind(this);
    this.toggle = this.toggle.bind(this);
    this.refresh = this.refresh.bind(this);
    this.sift = this.sift.bind(this);

    this.closedJot = React.createRef();

  }

  componentDidMount(){

// console.log('did we mount?')

    this.refreshDice();
    this.refreshTodo();
    this.refreshSort();


    if( this.spanElement.offsetTop > 9 ){
      // console.log( this.spanElement.offsetTop, this.spanElement.offsetTop > 9 ); //https://stackoverflow.com/a/44039401
      this.setState({
        multiline: true
      });
    } else {
      this.setState({
        multiline: false
      });
    }

    if( this.props.isFunctionJot === 'search' ){
      this.setState({
        sort: 0
      });
    }

    // determine scroll to new jot
    let path = this.getPath(-1);

    if( path &&
      roots.indexOf( this.props.start ) === -1 &&
      ! this.isFunctionJot && 
      path[ this.props.value ].hasOwnProperty('__focus')
    ){

      // this jot was just added. Scroll to it and remove its __focus key.

      let scrollDelay = 500;

      this.centerJot( scrollDelay );
      this.shakeJot( scrollDelay + 100 );
      this.stopShakeJot( scrollDelay * 3 );

      delete path[ this.props.value ]['__focus'];

      this.props.persist();

    }

  }

  componentDidUpdate( prevProps, prevState ){

    if( prevState.recentlyclosed === false && this.state.recentlyclosed === true ){
      // we just closed a jot and now we are in the recentlyclosed phase.
      // set up the timer until the end of this phase.

      this.centerJot();

    }

    if( prevState.recentlyclosed === true && this.state.recentlyclosed === false ){
      // the jot was closed

      this.shakeJot();

    }

    if( prevState.shake === false && this.state.shake === true ){
      // we are in a shaking state. Set it up to end

      this.stopShakeJot();
    }

  }

  centerJot = ( ms = 0 ) => {

    let recentlyclosedlength = 0;

    if( this.props.getConfig('jot-center-on-close') ){

      setTimeout( () => {

        this.closedJot.current.scrollIntoView(
          // { behavior: 'smooth' }
          { block: 'center', inline: 'center' }
        );

      }, ms );

      recentlyclosedlength = 10;//this was 300ms before when I was using smooth scrolling on scrollIntoView. Instant scrolling needs no such affordances of time. Technically I could set it to zero and I think it would still work fine.

    }

    setTimeout( () => {
        this.setState({
          recentlyclosed: false
        });
      }, recentlyclosedlength );

  }

  shakeJot = ( ms = 0 ) => {

    if( this.props.getConfig('jot-shake-on-close') ){
      // now we have probably scrolled to our closed jot, so shake it up!

      setTimeout( () => {

        this.setState({
          shake: true
        });

      }, ms )

    }

  }

  stopShakeJot = ( ms = 300 ) => {

    setTimeout( () => {
      this.setState({
        shake: false
      });
    }, ms );

  }

  refreshDice( e ){

    if( e ) e.stopPropagation();

    let dice = parseDice( this.props.value );
    let rolls = rollDice( dice );

    this.setState( (prevState) => ({
      dice,
      rolls
    }));

  }

  refreshTodo(){

    if( typeof this.props.value !== 'string' ) return;
    if( this.props.isFunctionJot ) return;

    let todo = this.props.value.match( /(todo|\[\]|remember( to)?|don'?t forget)/i );

    if( todo !== null ){
      // we have a todo jot.

      let strata = this.getPath();

      let todoval = strata.hasOwnProperty('__todo') ? strata['__todo'] : false;

      this.setState( () => ({
        todo_complete: todoval
      }));
    }

  }

  refreshSort(){

    if( this.props.isFunctionJot ) return;

    let strata = this.getPath();

    let sortval = strata.hasOwnProperty('__sort') ? strata['__sort'] : 0;

    this.setState({
      sort: sortval
    });

  }

  btn_add = () => {
    if( this.props.allowedActions.indexOf( 'add' ) === -1 ) return;
    if( ['__incoming','__recycled','__split'].indexOf( this.props.start ) === -1 ){
      return <button onClick={ this.add } className="btn btn-sm btn-outline-info mx-1">{ action_key['add'].full }</button>;
    }
  }

  btn_edit = () => {
    if( this.props.allowedActions.indexOf( 'edit' ) === -1 ) return;
    if( roots.indexOf( this.props.start ) === -1 ){
      return <button onClick={ this.edit } className={"btn btn-sm btn-outline-info mx-1 float-right" + ( this.state.multiline ? ' mt-1' : '' ) }>{ action_key['edit'].full }</button>;
    }
    return;
  }

  btn_recycle = () => {
    if( this.props.allowedActions.indexOf( 'recycle' ) === -1 ) return;
    if( roots.indexOf( this.props.start ) === -1 ){ // prevent this button from being rendered on any root HyperJots
      return <button onClick={ this.recycle } className="btn btn-sm btn-outline-info mx-1 ">{ action_key['recycle'].full }</button>;
    }
    return '';
  }

  btn_delete = () => {
    if( this.props.allowedActions.indexOf( 'delete' ) === -1 ) return;
    if( roots.indexOf( this.props.start ) === -1 ){ // prevent this button from being rendered on any root HyperJots
      return <button onClick={ this.del } className="btn btn-sm btn-outline-info mx-1 ">{ action_key['delete'].full }</button>;
    }
  }

  btn_copy = ( lr ) => {
    if( this.props.allowedActions.indexOf( 'copy' ) === -1 ) return;
    if( roots.indexOf( this.props.start ) === -1 ){
      return <button onClick={ this.copy } className={ "btn btn-sm btn-outline-info mx-1 " + ( lr ? 'float-' + lr : '' ) }>{ action_key['copy'].full }</button>;
    }
  }

  btn_move = () => {
    if( this.props.allowedActions.indexOf( 'move' ) === -1 ) return;
    if( roots.indexOf( this.props.start ) === -1 ){
      return <button onClick={ this.move } className="btn btn-sm btn-outline-info mx-1">{ action_key['move'].full }</button>;
    }
  }

  btn_move_select = () => {
    if( this.props.allowedActions.indexOf( 'move_select' ) === -1 ) return;

    // we must have a jot being moved in state first.
    if( this.props.moveJot ){

      // console.log( this.props.start, this.props.moveJot.props.start );
      // console.log( this.props.start.indexOf( this.props.moveJot.props.start ) > -1 , this.props.moveJot.props.start.indexOf( this.props.start ) > -1 );

      // can't move a jot into itself
      if( this.props.start === this.props.moveJot.props.start ){
        return;
      }

      // can't move a jot into it's parent (it's already there!)
      if( this.props.start === this.props.moveJot.props.start.split( this.props.store['__split'] ).slice(0,-1).join( this.props.store['__split'] ) ){
        return;
      }

      // can't move a jot into it's child (like dividing by zero!)
      if( this.props.start.indexOf( this.props.moveJot.props.start ) > -1 ){
        return;
      }

    }

    // if( roots.indexOf( this.props.start ) === -1 ){ // let us move stuff into the root.
    return <button onClick={ this.move_select } className="btn btn-sm btn-outline-info mx-1">{ action_key['move_select'].full }</button>;
    // }
  }

  btn_share = () => {
    if( this.props.allowedActions.indexOf( 'share' ) === -1 ) return;
    if( roots.indexOf( this.props.start ) === -1 ){
    return <button onClick={ this.share } className="btn btn-sm btn-outline-info mx-1">{ action_key['share'].full }</button>;
    }
  }

  btn_url = () => {
    if( this.props.allowedActions.indexOf( 'url' ) === -1 ) return;
    if( roots.indexOf( this.props.start ) === -1 ){
      if( /^https?:\/\//i.test( this.props.value ) ){
        return <button onClick={ this.url } className={"btn btn-sm btn-outline-info mx-1 float-right" + ( this.state.multiline ? ' mt-1' : '' )} >{ action_key['url'].full }</button>;
      }
    }
  }

  btn_export = () => {
    if( this.props.allowedActions.indexOf( 'export' ) === -1 ) return;
    if( roots.indexOf( this.props.start ) !== -1 ){
      return <button onClick={ this.export_json } className="btn btn-sm btn-outline-info mx-1">{ action_key['export'].full }</button>;
    }
  }

  btn_import = () => {
    if( this.props.allowedActions.indexOf( 'import' ) === -1 ) return;
    if( roots.indexOf( this.props.start ) !== -1 ){
      return <span><button onClick={ this.import_json } className="btn btn-sm btn-outline-info mx-1">{ action_key['import'].full }</button></span>;
    }
  }

  btn_reroll = () => {
    if( this.props.allowedActions.indexOf( 'reroll' ) === -1 ) return;
    if( this.state.dice === null ) return;
    if( roots.indexOf( this.props.start ) === -1 ){
      return <button onClick={ this.refreshDice } className={ "btn btn-sm btn-outline-info mx-1 "}>{ action_key['reroll'].full }</button>;
    }
  }

  btn_counter = ( which ) => {
    if( this.props.allowedActions.indexOf( 'counter' ) === -1 ) return;
    if( this.props.isFunctionJot ) return;
    if( roots.indexOf( this.props.start ) === -1 ){
      if( typeof this.props.value === 'string' ){
        let num = this.props.value.match( leadingNumberRegexp );
        if( num !== null ){
          // we have a leading nunmber. Render the counter controls.
          return <button onClick={ (e) => { e.stopPropagation(); this.counter( which === 'increment' ? 1 : -1 ) } } className={ "btn btn-sm btn-outline-info mx-1 float-right"}>{ action_key[ which ].full }</button>;
        }
      }
    }
  }

  btn_sort = () => {
    if( this.props.allowedActions.indexOf( 'sort' ) === -1 ) return;

    let s = this.state.sort;
    if( isNaN(s) || s >= sorts.length ) s = 0;
    return <button onClick={ this.cycleSort } className="btn btn-sm btn-outline-info mx-1">{ action_key['sort-' + sorts[ s ] ].full }</button>;
  }

  cycleSort(e){

    e.stopPropagation();

    this.setState( (prevState) => {

      let current_sort =  isNaN(prevState.sort) || prevState.sort >= sorts.length ? 0 : prevState.sort;

      let new_sort = current_sort + 1;

      if( new_sort >= sorts.length ){
        new_sort = 0;
      }

      let path = this.getPath(-1);

      // set new key
      if( roots.indexOf( this.props.start ) > -1 ){
        path[ this.props.start ]['__sort'] = new_sort;
      } else {
        path[ this.props.value ]['__sort'] = new_sort;
      }

      // this.props.refresh();
      this.props.persist();

      return {
        sort: new_sort
      };

    });

  }

  btn_todo = () => {
    if( this.props.allowedActions.indexOf( 'todo' ) === -1 ) return;
    if( this.props.isFunctionJot ) return;
    if( this.state.todo_complete === null ) return;
    if( roots.indexOf( this.props.start ) === -1 ){
        return <span onClick={ (e) => { e.stopPropagation(); if( this.props.isSearchResult ) return; this.todoToggle(); } } className={ "float-left"}>{ action_key['todo-' + ( this.state.todo_complete ? 'complete' : 'incomplete' ) ].full }&nbsp;</span>;
    }
  }

  todoToggle(){

    // var t = this;

    this.setState( (prevState) => {

      let newval = ( prevState.todo_complete !== null ? ! prevState.todo_complete : false );

      let path = this.getPath(-1);

      // set new key
      path[ this.props.value ]['__todo'] = newval;
      // path[ this.props.value ]['__timestamp'] = Date.now();
      path[ this.props.value ]['__updated'] = this.formatDate( true, true );

      this.props.refresh();
      this.props.persist();

      // force app to rerender if available (used for config updates)
      if( this.props.forceReRender !== undefined ) this.props.forceReRender();
      // this.props.forceReRender();
      // console.log( this.props )

      return {
        todo_complete: newval
      };

    });


  }

  counter( amt ){
     let oldval = this.props.value.match( leadingNumberRegexp );
     if( oldval === null ) return;

     let current = parseFloat( oldval[0] );

     current += amt;

     // console.log( oldval, this.props.value.substr( this.props.value.indexOf( oldval[0] ) + oldval[0].length ) )

     let newval = '' + current + this.props.value.substr( this.props.value.indexOf( oldval ) + oldval[0].length );

     this.editCallback()( newval );
  }

  test_image = ( val ) => {

    if( /^https?:\/\/[^\s]+\/.+\.(png|jpg|jpeg|gif)$/i.test( val ) ){
      return true;
    }

    return false;

  }


  color = () => {
    // if( typeof this.props.value !== 'string' ) return;
    if( this.props.isFunctionJot ) return;
    let beginning = this.props.value.split(' ')[0];
    if( /^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})/.test( beginning ) ){
      if( this.state.customColor !== beginning ){
        this.setState({
          customColor: beginning
        });
      }
    }
  }

  getPath = ( slice_end ) => {

    if( slice_end === undefined ){

      let split = this.props.start.split( this.props.store['__split'] );
      let reduced = split.reduce( (obj, indx) => {
        return obj[ indx ];
      }, this.props.store );

      return reduced;

      // var path;

      // var path_parts = this.props.start.split( this.props.store['__split'] );

      // path = path_parts.reduce(
      //   ( obj, indx ) => {
      //     var next = obj[ indx ];
      //     return next;
      //   },
      //   this.props.store
      // );

      // return path;

    } else if( typeof slice_end === 'number' ){

      return this.props.start.split( this.props.store['__split'] ).slice(0, slice_end ).reduce( (obj, indx) => obj[ indx ], this.props.store );

    }
  }

  addCallback(){
    let t = this;
    return ( val ) => {
      if( val !== '' && val !== null && val !== false && reserved.indexOf( val ) === -1 ){
        // get the parent of the current jot
        let path = t.getPath();

        // var remount = false;// this was probably a bad idea.

        // don't clobber existing jots by the same name
        if( ! path.hasOwnProperty( val ) ){
          // set new key
          path[ val ] = {
            "__created": t.formatDate( true, true ),
            "__updated": t.formatDate( true, true ),
            "__timestamp": Date.now(),
            "__focus": true,
          };

          toast('✨ New Jot created!');

        } else {
          toast('⚠️😱 Can\'t add another Jot with identical value!');

          // was trying to scroll duplicate jot into view
          // path[ val ]['__focus'] = true;
          path[ val ]['__timestamp'] = Date.now();
          // remount = true;
        }

        if( roots.indexOf( t.props.start ) === -1 ){
          t.props.refresh();
        } else {
          // t.refresh( remount );
          t.refresh();
        }
      }
      // when we call persist, the local storage is updated with the latest change in values.
      t.props.persist();
    }
  }

  add(e){
    e.stopPropagation();
    this.props.requestModal( 'add', this.addCallback(), '' );
  }

  editCallback(){
    let t = this;
    return ( val ) => {
      let path = t.getPath( -1 );
      if( val !== false && val !== null && val !== '' && val !== t.props.value && ! path.hasOwnProperty( val ) && reserved.indexOf( val ) === -1 ){
        // set new key
        path[ t.props.value ]['__updated'] = t.formatDate( true, true );
        path[ t.props.value ]['__timestamp'] = Date.now();
        path[ t.props.value ]['__focus'] = true;


        if( path[ t.props.value ].hasOwnProperty('__todo') ){
          // reset todo when edited
          path[ t.props.value ]['__todo'] = false;
        }

        path[ val ] = path[ t.props.value ];
        // delete the old key
        delete path[ t.props.value ];

        toast('✅ Jot edited!');

        t.props.refresh();
      }
      t.props.persist();
    }
  }

  edit(e){
    e.stopPropagation();
    this.props.requestModal( 'edit', this.editCallback(), this.props.value );
  }

  recycleCallback(){
    let t = this;
    return () => {
      // let shortname = '"' + t.props.value.substr(0,25) + ( t.props.value.length > 25 ? '...' : '') + '"';
      // let doit = window.confirm('Delete ' + shortname + ' and everything stored in it?');
      // if( doit ){

        // get the parent of the current jot
        let path = t.getPath( -1 );

        // move to recycle bin
        this.props.store['__recycled'] = {
          ...this.props.store['__recycled'],
          [t.props.value]: path[ t.props.value ]
        };

        // delete the old key
        delete path[ t.props.value ];

        t.props.refresh();
      // }
      t.props.persist();
    }
  }

  recycle(e){
    e.stopPropagation();
    this.props.requestModal( 'recycle', this.recycleCallback(), this.props.value, this.props );
  }

  importCallback(){
    // https://stackoverflow.com/a/36198572
    let t = this;
    return ( valnull, that ) => {
      if( that.importInput.current !== null ){ // make sure the element/ref exists currently.
        let files = that.importInput.current.files;
        if( files.length <= 0 ){
          console.log('No files selected');
          return;
        }
        let reader = new FileReader();
        reader.onload = (e) => {
          var result = false;
          if( e && e.target && e.target.result ){
            try {

              result = JSON.parse( e.target.result );

            } catch( e ){

              console.log('JSON Parse error:', e);
              return;

            }
            if( result !== false ){
              // valid json!
              // check for valid hyperjot:
              if(
                result.hasOwnProperty('__split') &&
                // result['__split'] === '⋱' &&
                result.hasOwnProperty('__root') &&
                result.hasOwnProperty('__recycled') &&
                result.hasOwnProperty('__incoming') &&
                result.hasOwnProperty('__search')
              ){
                // valid hyperjot.
                // recycle the old hyperjot
                let old = {
                  "HyperJot": t.props.store['__root'],
                  "HyperSift": t.props.store['__search'],
                  "HyperShares": t.props.store['__incoming'],
                  "Recycled Jots": t.props.store['__recycled'],
                };

                // save the new hyperjot
                t.props.store['__root'] = result['__root'];
                t.props.store['__search'] = result['__search'];
                t.props.store['__incoming'] = result['__incoming'];
                t.props.store['__recycled'] = result['__recycled'];
                // notice we are not saving split. This prevents weird issues.
                t.props.store['__recycled'][ "Old HyperJot (replaced via import " + t.formatDate( true, true ) + ")" ] = old;

                t.props.persist();
                t.refresh();

                toast('😅 Import complete! Whew, that was a big one!');

              } else console.log('Invalid HyperJot.json');
            } else console.log('No JSON captured from Parse.');
          } else console.log('No object in reader.onload handler');
        };
        reader.readAsText( files.item(0) );
      } else console.log('Import element not available');
    }
  }

  import_json(e){
    e.stopPropagation();
    // https://stackoverflow.com/a/36198572
    this.props.requestModal( 'import', this.importCallback(), '' );
  }

  del(e){
    e.stopPropagation();
    delete this.getPath( -1 )[ this.props.value ];
    this.props.persist();
    this.props.refresh();
  }

  copy(e){
    e.stopPropagation();
    // console.log( 'func jot: ',this.props.isFunctionJot );
    if( this.props.isFunctionJot === 'sum' ){
      copy( '' + this.props.value.props.children[1].props.children );
      // console.log('copy value', this.props.value.props.children[1].props.children, this.props.value.props );
    } else if( this.props.isFunctionJot === 'rand' ){

      copy( this.props.value.substr(3) );

    } else {
      copy( this.props.value );
    }

    toast( 'Copied!' );
  }

  move(e){
    e.stopPropagation();
    // store the jot we want to move in the application state.
    this.props.requestMove( this ); // look at createRequestMoveFunc()
    this.props.requestModal( 'move', null, this.props.value, this.props );
  }

  move_select(e){
    e.stopPropagation();
    this.props.performMove( this ); // look at createPerformMoveFunc()
  }

  getUnreservedJots( obj ){
    // recursively return jots that aren't meta-jots, reserved, or root.

    let pruned = {};

    for( var key in obj ){
      if( reserved.indexOf( key ) === -1 ){
        if( obj[key].constructor.name === 'Object' ){
          pruned[ key ] = this.getUnreservedJots( obj[ key ] );
        } else {
          pruned[ key ] = obj[ key ];
        }
      }
    }

    return pruned;

  }

  share(e){
    e.stopPropagation();
    let subjots = this.getPath(-1)[ this.props.value ];
    // ensure we don't send unnecessary metadata that balloons the size of the hypershare.
    // this may be a bad idea to remove it but we can always comment this out.
    let pruned_subjots = this.getUnreservedJots( subjots );

    copy( window.location.protocol + '//' + window.location.host + '/?add=' + encodeURIComponent( JSON.stringify( { [ this.props.value ]: pruned_subjots } ) ) );
    // copy( window.location.protocol + '//' + window.location.host + '/?add=' + encodeURIComponent( JSON.stringify( { [ this.props.value ]: subjots } ) ) );

    toast( 'A shareable link has been copied!' );
  }

  url(e){
    e.stopPropagation();
    window.open( this.props.value.split(' ')[0] , '_blank' );

    let path = this.getPath(-1);

    // set new key
    path[ this.props.value ]['__timestamp'] = Date.now();

    this.props.refresh();
    this.props.persist();
  }

  formatDate( pretty_bool, time_bool ){

    // time_bool prints time as well
    // pretty_bool prints without hyphenation

    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    var now = new Date();
    var dd = now.getDate();
    // var mm = now.getMonth()+1; //January is 0!
    var mm = monthNames[ now.getMonth() ].substr(0,3);
    var yyyy = now.getFullYear();

    if(dd<10) {
        dd = '0'+dd
    }

    if(mm<10) {
        mm = '0'+mm
    }

    var today;

    if( !pretty_bool ){
      today = mm.toLowerCase() + '-' + dd + '-' + yyyy;
    } else {
      today = mm + ' ' + dd + ' ' + yyyy;
    }

    if( time_bool ){
      var time = ' ' + now.toLocaleTimeString();
      today += time;
    }


    return today;

  }

  downloadObjectAsJson(exportObj, exportName = false ){
    // https://stackoverflow.com/a/30800715
    var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj, null, "\t"));
    var downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href",     dataStr);
    if( ! exportName ) exportName = this.formatDate();
    var filename = 'hyperjot-export-' + exportName + '.json';
    downloadAnchorNode.setAttribute("download", filename);
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }

  export_json(e){
    e.stopPropagation();
    // create json file.
    // var contents = JSON.stringify( this.store, null, "\t" );
    this.downloadObjectAsJson( this.props.store );
    toast('💾 Export complete.');
  }

  toggle(e){

    if( e ) e.stopPropagation();

    this.setState( prevState => {

      // console.log('cache-sort-on-open', this.props.getConfig('cache-sort-on-open') );

      // save timestamp
      if( roots.indexOf( this.props.start ) === -1 && ! this.props.isFunctionJot && prevState.expanded === true ){
        // setting prev expanded to true makes the jot jump after closing or when a child closes. false means jump right when opening.
        let path = this.getPath(-1);

        // set new key
        path[ this.props.value ]['__timestamp'] = Date.now();

        this.props.refresh();
        this.props.persist();

      }

      var update = {
        expanded: ! prevState.expanded
      };

      if( prevState.recentlyclosed === false && prevState.expanded === true ){
        // changerecentlyclosed 
        update.recentlyclosed = true;
        
      }

      return update;

    });

  }

  refresh( old_school ){
    // console.log( old_school );
    // this.forceReRender ? this.forceReRender() : null;

    // old toggle method might break dom stuff. disabling permanently:
    old_school = false;

    if( old_school ){
      // close and reopen parent jot
      this.toggle();
      this.toggle();

    } else {
      // use react to update
      this.forceUpdate();

    }
  }

  sortJots = ( content ) => {

    if( this.state.sort === 0 ){
      // alpha sort
      // console.log('alpha sort')
      content = content.sort( (a,b) => {
        if( a.key < b.key ) return -1;
        if( a.key > b.key ) return 1;
        return 0;
      });
    } else if( this.state.sort === 1 ){
      // cache sort
      // console.log('cache sort')
      content = content.sort( (a,b) => {
        // console.log('a',a.props.timestamp,'b',b.props.timestamp)
        if( a.props.timestamp === undefined && b.props.timestamp !== undefined ) return 1;
        if( b.props.timestamp === undefined && a.props.timestamp !== undefined ) return -1;
        if( a.props.timestamp > b.props.timestamp ) return -1;
        if( a.props.timestamp < b.props.timestamp ) return 1;
        return 0;
      });
    } else if( this.state.sort === 2 ){
      // secret dragon drop sorting
      content = content.sort( (a,b) => {
        if( isNaN( a.props.order ) && isNaN( b.props.order ) ){
          // do alpha since neither jot has an order.
          if( a.key < b.key ) return -1;
          if( a.key > b.key ) return 1;
        }
        if( isNaN( a.props.order ) && ! isNaN( b.props.order ) ){
          // a has no order but b does
          return 1; // move a down the list
        }
        if( ! isNaN( a.props.order ) && isNaN( b.props.order ) ){
          // b has no order but a does
          return -1; // move b down the list
        }
        if( a.props.order < b.props.order ) return -1;
        if( a.props.order > b.props.order ) return 1;
        return 0;
      });
    }

  }

  countSubJots(){
    if( this.props.isFunctionJot ) return 0;

    let strata = this.getPath();
    let subjots = 0;
    for( var k in strata ){
      if( strata.hasOwnProperty( k ) && reserved.indexOf( k ) === -1 ){
        subjots++;
      }
    }
    return subjots;
  }


  sift( reg, content, path, obj, sum_set ){

    for( var key in obj ){

      if( reserved.indexOf( key ) > -1 ) continue;

      // recurse
      this.sift( reg, content, path + this.props.store['__split'] + key, obj[ key ], sum_set );

      if( typeof reg === "object" ){
        if( reg.test( key ) ){
          content.push(<HyperJot isSearchResult={ true } key={key} value={key} start={ path + this.props.store['__split'] + key } refresh={ this.refresh } store={ this.props.store } persist={ this.props.persist } requestModal={ this.props.requestModal } requestMove={ this.props.requestMove } performMove={ this.props.performMove } allowedActions={ ['copy','date','todo','share','sort'] } moveJot={ this.props.moveJot } getConfig={ this.props.getConfig } />);
          if( key.match( numbersRegexp ) ){
            sum_set.push( key.match( numbersRegexp ) );
          }
        }
      } else {
        if( reg.indexOf( key ) > -1 ){
          content.push(<HyperJot isSearchResult={ true } key={key} value={key} start={ path + this.props.store['__split'] + key } refresh={ this.refresh } store={ this.props.store } persist={ this.props.persist } requestModal={ this.props.requestModal } requestMove={ this.props.requestMove } performMove={ this.props.performMove } allowedActions={ ['copy','date','todo','share','sort'] } moveJot={ this.props.moveJot } getConfig={ this.props.getConfig } />);
          if( key.match( numbersRegexp ) ){
            sum_set.push( key.match( numbersRegexp ) );
          }
        }
      }
    }

  }


  renderSiftJots(){

    // if( this.props.isFunctionJot ) return;

    let strata = this.getPath();
    let content = [];
    // let split = this.props.store['__split'];

    if( this.props.isFunctionJot === 'search' ){

      // here we are rendering the sift results inside of the sift search.
      let sum_set = [];

      var reg = false;
      try {
        reg = new RegExp( this.props.value, 'i' );
      } catch( e ){
        // error here.
      }

      if( reg === false ) reg = this.props.value; // Regular expression did not validate, so search based on the literal text of the prop value.

      this.sift( reg, content, '__root', this.props.store['__root'], sum_set );

      this.sortJots( content );

      // add sum function jot
      if( sum_set.length > 1 ){
        let summation = <span><span className="Rajdhani">{"\u2211"}</span><span className="not-Rajdhani">{ sum_set.reduce( ( a, x ) => parseFloat(x) + parseFloat(a) , 0 ) }</span></span>;
        content.push(<HyperJot isFunctionJot={ 'sum' } key={ this.props.store['__split'] + 'sum' } start={ this.props.store['__split'] + 'sum' } value={ summation } store={ this.props.store } persist={ this.props.persist } allowedActions={ this.props.allowedActions.indexOf('copy') !== -1 ? ['copy'] : [] } getConfig={ this.props.getConfig } />);
      }

    } else {

      // We are rendering the search Jots immediately inside of HyperSift here. Nothing else.
      for( var k in strata ){
        if( strata.hasOwnProperty( k ) && reserved.indexOf( k ) === -1 ){ // prevent enumeration of internal keys like updated date.
          content.push(<HyperJot isFunctionJot="search" key={k} value={k} start={ this.props.start + this.props.store['__split'] + k } refresh={ this.refresh } store={ this.props.store } persist={ this.props.persist } requestModal={ this.props.requestModal } requestMove={ this.props.requestMove } performMove={ this.props.performMove } allowedActions={ ['edit','delete','copy','date'] } moveJot={ this.props.moveJot } getConfig={ this.props.getConfig } />);
        }


      } // end for loop

    }

    return content;

  }



  renderSubJots(){

    if( this.props.isFunctionJot && this.props.isFunctionJot !== 'search' ) return;

    let strata = this.getPath();
    let content = [];
    let sum_set = [];
    let split = this.props.store['__split'];

    for( var k in strata ){
      if( strata.hasOwnProperty( k ) && reserved.indexOf( k ) === -1 ){ // prevent enumeration of internal keys like updated date.
        let order = strata[k]['__order'];
        let timestamp = strata[k]['__timestamp'];
        // console.log( "order for " + k, order );
        if( order ) order = parseFloat( order );
        // if( isNaN( order ) ) order = Infinity;

        content.push(
          <HyperJot
            isSearchResult={ this.props.isSearchResult /*this is so that todos in the news hyperjot can't be toggled */ }
            key={k}
            order={ order }
            timestamp={ timestamp }
            value={k}
            start={ this.props.start + this.props.store['__split'] + k }
            refresh={ this.refresh }
            store={ this.props.store }
            persist={ this.props.persist }
            requestModal={ this.props.requestModal }
            requestMove={ this.props.requestMove }
            performMove={ this.props.performMove }
            allowedActions={ this.props.allowedActions }
            moveJot={ this.props.moveJot }
            forceReRender={ this.props.forceReRender }
            getConfig={ this.props.getConfig }
          />
        );
      }

      sum_set = sum_set.concat( k.match( numbersRegexp ) || [] );

    } // end for loop

    this.sortJots( content );

    // add random function jot
    if( this.state.rolls ){

      let rolls = this.state.rolls.map( (x, i) => {
        let critical = x[0] === x[1] ? ' 💥' : '';
        if( x[0] !== 'undefined' ) sum_set.push( x[0] ); // add to total in jot
        return <HyperJot
                isFunctionJot='rand'
                sides={ x[1] }
                result={ x[0] }
                key={ split + 'rand' + i }
                start={ split + 'rand' }
                value={ "🎲 " + x[0] + critical }
                store={ this.props.store }
                persist={ this.props.persist }
                allowedActions={ this.props.allowedActions.indexOf('copy') !== -1 ? ['copy'] : [] }
                getConfig={ this.props.getConfig }
                />
      } );

      // console.log(this.state.rolls);
      // console.log(rolls);

      content.unshift( rolls );

    }

    // add sum function jot
    if( sum_set.length > 1 ){
      let summation = <span><span className="Rajdhani">{"\u2211"}</span><span className="not-Rajdhani">{ sum_set.reduce( ( a, x ) => parseFloat(x) + parseFloat(a) , 0 ) }</span></span>;
      content.push(<HyperJot isFunctionJot={ 'sum' } key={ split + 'sum' } start={ split + 'sum' } value={ summation } store={ this.props.store } persist={ this.props.persist } allowedActions={ this.props.allowedActions.indexOf('copy') !== -1 ? ['copy'] : [] } getConfig={ this.props.getConfig } />);
    }

    return content;
  }

  show_created_updated(){
    if( this.props.isFunctionJot ) return;

    if( this.props.allowedActions.indexOf( 'date' ) === -1 ) return;

    let strata = this.getPath();

    if( strata === undefined ) return;

    var created = false, updated = false;

    if( strata.hasOwnProperty('__created') ){
      created = <small className="m-1 p-1">Created {strata['__created']}</small>;
    }
    if( strata.hasOwnProperty('__updated') ){
      updated = <small className="m-1 p-1">Updated {strata['__updated']}</small>;
    }

    if( created && updated )
      return <span className="created-updated">{created}<br/>{updated}{ strata['__updated'].indexOf('4:20') > -1 ? <img style={ { width: 20, height: 20 } } alt="420 meme" src={ meme }/> : '' }</span>;

    if( ! created && updated )
      return <span className="created-updated">{updated}{ strata['__updated'].indexOf('4:20') > -1 ? <img style={ { width: 20, height: 20 } } alt="420 meme" src={ meme }/> : '' }</span>;

    return;
  }

  shake = ( inj ) => {
    if( this.state.shake && this.props.getConfig('jot-shake-on-close') ){
      return <Shake
        h={5}
        v={15}
        r={1}
        dur={400}
        int={10}
        max={100}
        fixed={ true } >
          { inj }
        </Shake>;
    } else {
      return inj;
    }
  }

  render(){

    let sift = this.props.start.split( this.props.store['__split'] )[0] === '__search'; // is this a jot immediately inside the __search key or not? These are Sifts, and they load matching jots. The jots below them have restricted abilities.

    if( this.state.expanded ){
      // open jot

      let form = '';
      let formthreshold = 30;
      if( typeof this.props.value === 'string' ){
        let valuelength = this.props.value.split(' ').length;
        if( valuelength > formthreshold ) form = 'longform';
        if( valuelength <= formthreshold ) form = 'shortform';
      }

      return (
        <div className={"jot clearfix m-1 p-1 pt-2 expanded-" + this.state.expanded + ' ' + form + ' ' + ( this.state.shake && this.props.getConfig('jot-shake-on-close') ? 'shake' : '') } onClick={ this.toggle }>

          <span className="jot-title pb-1">{ this.btn_todo() }{ sift && this.props.isFunctionJot ? '🔎 ' : ''}{ this.test_image( this.props.value ) ? <img alt="Loaded dynamically via HyperJot.io." src={ this.props.value } className="img-fluid fullImage" /> : ( this.state.todo_complete !== null ? this.props.value.replace(/^(todo|\[\])/i, '') : this.props.value ) }</span>

          <div className="actions mb-2">
            { this.btn_add() }
            { this.btn_import() }
            { this.btn_export() }
            { this.btn_copy() }
            { this.btn_share() }
            { this.btn_move() }
            { this.btn_move_select() }
            { this.btn_recycle() }
            { this.btn_sort() }
            { this.btn_reroll() }
            { this.btn_delete() }
            { this.color() }
          </div>

          { sift ? this.renderSiftJots() : this.renderSubJots() }
          { this.props.isFunctionJot === 'sum' ? "Sum of all numbers in this Jot" : '' }
          { this.props.isFunctionJot === 'rand' ? "Rolling a die with " + this.props.sides + " side" + ( Math.abs( this.props.sides ) === 1 ? "" : "s" ) + " yielded " + this.props.result + ( this.props.sides === this.props.result ? ' - Critical!' : '' ) : '' }
          { this.show_created_updated() }
        </div>
      )
    } else {
      // closed jot
      return this.shake(
        <div ref={ this.closedJot } style={ this.state.customColor ? { backgroundColor: this.state.customColor } : {} } className={"jot clearfix m-2 p-2 expanded-" + this.state.expanded + ' ' + ( this.props.styleClass ? this.props.styleClass : '' ) + ' ' + ( this.countSubJots() > 0 ? '' : 'no-sub-jots' ) + ' ' + ( this.state.shake && this.props.getConfig('jot-shake-on-close') ? 'shake' : '') } onClick={ this.toggle }>
          { this.btn_todo() }
          { sift && this.props.isFunctionJot ? '🔎 ' : ''}
          { this.test_image( this.props.value ) ? <span className="previewImage"><img alt="Loaded dynamically via HyperJot.io." src={ this.props.value } className="img-fluid" /></span> : ( this.state.todo_complete !== null ? this.props.value.replace(/^(todo|\[\])/i, '') : this.props.value ) }
          <span className="outside-actions" ref={ (spanElement) => this.spanElement = spanElement }>
            { this.btn_edit() }
            { this.btn_counter('increment') }
            { this.btn_counter('decrement') }
            { this.btn_url() }
            { this.props.isFunctionJot && this.props.isFunctionJot !== 'search' && this.props.isSearchResult === false ? this.btn_copy('right') : '' }
            { this.color() }
          </span>
        </div>
      );
    }
  }
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js